import React from 'react'
import ReactDOM from 'react-dom'
import locale from 'locale'

export default class DeliveryDate extends React.Component {
  render() {
    let value = this.props.delivery
    let immediately = this.props.immediately || false

    let date = new Date()
    date.setDate(1)

    let dateParser = locale().dateParser({ raw: 'yyyy-MM-dd' })
    let immediatelyFormatter = locale().dateFormatter({ raw: 'yyyy-MM-dd' })
    let text = locale().dateFormatter({ raw: 'MMMM yyyy' })(dateParser(value))

    if (immediately === true && immediatelyFormatter(date) === value) {
      text = 'Immediately'
    }

    return <span>{text}</span>
  }
}
